import { US_STATE_NAMES, type UsStateName } from '@nesso/common-contracts/us-states';

export function toUsStateName(stored: string): UsStateName | '' {
    return US_STATE_NAMES.find((name) => name === stored) ?? '';
}
